export default {
    ios: /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent),
    android: /(android|linux.*mobile)/i.test(navigator.userAgent),
    xinhua: /XinHuaNet/i.test(navigator.userAgent),
    wechat: navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'
}